import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import React from "react";
import { Helmet } from "react-helmet";

const Starter = () => {
  const navigate = useNavigate();
  const [hasUserScrolled, setHasUserScrolled] = useState(false);
  const elementRefs = useRef([...Array(17)].map(() => React.createRef()));
  const timeoutRef = useRef(null);
  const isAutoScrolling = useRef(false);

  const userObjString = localStorage.getItem("salla_discourse_user");
  const userObj = JSON.parse(userObjString);

  //flag this user as visited the start page on page visit
  if (userObj && userObj?.username) {
    localStorage.setItem(userObj.username, "true");
  }

  // Framer Motion variants (as you already defined)
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        when: "beforeChildren",
        delayChildren: 0.3,
        staggerChildren: 1,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", bounce: 0.6, duration: 1 },
    },
  };

  const contents = [
    <div className="flex">
      <img src="/images/sparkles_2728.png" alt="emoji" className="w-6" />
      <bdi className=" text-[#707070]">حيّاك الله في مجتمع سلة.</bdi>
    </div>,
    <div className="flex">
      <img src="/images/sparkles_2728.png" alt="emoji" className="w-14" />
      <img src="/images/waving-hand_1f44b.png" alt="emoji" className="w-14" />
    </div>,
    <>
      <bdi className=" text-[#707070]">
        سواءً كنت تاجر جديد في السوق أو تاجر مخضرم فهذا كيانك، وهنا مكانك. مجتمع
        سلة يوفر لك مساحة مفتوحة لتبادل التجارب، طرح الأسئلة، مشاركة الآراء
        والنقاشات، وطلب الدعم من التجار وفريق سلة بشكل مباشر وتفاعلي.
      </bdi>
    </>,
    <>
      <bdi className=" text-[#707070] font-bold">إيش ينتظرك في مجتمع سلة؟</bdi>
    </>,
    <>
      <div className=" flex items-center justify-end gap-1 mb-1">
        <bdi className=" text-[#707070] font-bold mt-1">الصفحه الرئيسية</bdi>
        <img
          src="/images/house-with-garden_1f3e1.png"
          alt="emoji"
          className="w-4"
        />
      </div>
      <bdi className="text-[#707070]">
        {" "}
        خذ نظرة على المجتمع، واطّلع على المنشورات الجديدة أو الأكثر مشاهدة.
      </bdi>
    </>,
    <>
      <div className=" flex items-center justify-end gap-1 mb-1">
        <bdi className=" text-[#707070] font-bold mt-1">أخبار سلة</bdi>
        <img src="/images/memo_1f4dd.png" alt="emoji" className="w-4" />
      </div>
      <bdi className="text-[#707070]">
        حلقة وصل بينك وبين فريق سلة، تقدر من خلالها تعرف آخر تحديثات المنصة،
        وتجربّها، وتتفاعل معاها، وتعطي رأيك مباشرة للفريق.
      </bdi>
    </>,
    <>
      <div className=" flex items-center justify-end gap-1 mb-1">
        <bdi className=" text-[#707070] font-bold mt-1">تجارب التجار</bdi>
        <img
          src="/images/man-detective_1f575-fe0f-200d-2642-fe0f.png"
          alt="emoji"
          className="w-4"
        />
      </div>
      <bdi className="text-[#707070]">
        شارك تجربتك واستفيد من تجارب غيرك من التجار، سواءً في تحديات السوق،
        الشحن والتوصيل، خبراتهم في التجارة وغيرها.
      </bdi>
    </>,
    <>
      <div className=" flex items-center justify-end gap-1 mb-1">
        <bdi className=" text-[#707070] font-bold mt-1">محتاج فزعة</bdi>
        <img
          src="/images/face-with-head-bandage_1f915.png"
          alt="emoji"
          className="w-4"
        />
      </div>
      <bdi className="text-[#707070]">
        لو واجهت أيّ إشكالية، فأكيد واجهها تاجر قبلك؛ وهنا تقدر تسأل التجار،
        تطلب دعمهم، أو تبحث عن الحل عبر خاصية البحث.
      </bdi>
    </>,
    <>
      <div className=" flex items-center justify-end gap-1 mb-1">
        <bdi className=" text-[#707070] font-bold mt-1">مصادر للتجار</bdi>
        <img
          src="/images/magnifying-glass-tilted-left_1f50d.png"
          alt="emoji"
          className="w-4"
        />
      </div>
      <bdi className="text-[#707070]">
        ولأن النمو والتوسع يتطلب معرفة؛ خصصنا لك قسم خاص بكل المصادر اللي تهم
        التاجر، من دورات تدريبية، مقالات، معلومات تسويقية وتعليمية، وغيرها.
      </bdi>
    </>,
    <>
      <div className=" flex items-center justify-end gap-1 mb-1">
        <bdi className=" text-[#707070] font-bold mt-1">مساحة إعلانية</bdi>
        <img
          src="/images/hundred-points_1f4af.png"
          alt="emoji"
          className="w-4"
        />
      </div>
      <bdi className="text-[#707070]">
        شارك آخر عروض وخصومات متجرك، وأعلن عن منتجاتك وخدماتك للتجار في سلة.
      </bdi>
    </>,
    <div className="flex">
      <img
        src="/images/police-officer_1f46e.png"
        alt="emoji"
        className="w-14"
      />
      <img
        src="/images/police-officer_1f46e.png"
        alt="emoji"
        className="w-14"
      />
    </div>,
    <>
      <div className=" flex items-center justify-end gap-1 mb-1">
        <img src="/images/prohibited_1f6ab.png" alt="emoji" className="w-4" />
        <bdi className=" text-[#707070] font-bold mt-1">ضوابط المشاركة</bdi>
      </div>
      <bdi className="text-[#707070]">
        يسعدنا اهتمامك بالانضمام لمجتمع سلة، <br />
        ولأنك صاحب تجارة فأنت صاحب أثر، وكل حرف تكتبه يؤثر على كل من يقرأه من
        تجار سلة، ولضمان مساحة آمنة لك ولكل التجار؛ نقدِّر حرصك وتعاونك في تجنب:{" "}
        <br />
        التسبب بالإزعاج، أو إرسال المنشورات العشوائية وغير اللائقة. <br />
        نشر محتوى يحتوي على فيروسات أو برامج ضارة. <br />
        التطرق إلى المواضيع الدينية، أو السياسية بأي شكل من الأشكال. <br />
        استخدام الألفاظ البذيئة، والتهديدات والهجوم الشخصي. <br />
        جمع بيانات الأعضاء أو نشر روابط تهدف إلى ذلك. <br />
        كتابة تعليقات غير مفيدة، أو بعيدة عن الموضوع الأساسي.
      </bdi>
    </>,
    <>
      <img src="/images/rocket_1f680.png" alt="emoji" className="w-14" />
    </>,
    <>
      <bdi className="text-[#707070] font-bold">
        والآن، تقدر تشارك، وتكون جزء من مجتمع تجار يلهمك وتلهمه !
      </bdi>
    </>,
    <>
      <div className=" flex items-center justify-end gap-1 mb-1">
        <img
          src="/images/saluting-face_1fae1.png"
          alt="emoji"
          className="w-4"
        />
        <bdi className=" text-[#707070] font-bold mt-1">جاهز تنضم معنا؟</bdi>
      </div>
    </>,
    <>
      <img
        src="/images/backhand-index-pointing-down_1f447.png"
        alt="emoji"
        className="w-14"
      />
    </>,
  ];

  useEffect(() => {
    window.scrollTo(0, 0);

    const handleScroll = () => {
      if (!isAutoScrolling.current && !hasUserScrolled) {
        setHasUserScrolled(true);
        clearTimeout(timeoutRef.current);
      }
    };

    window.addEventListener("scroll", handleScroll);

    const scrollToElement = (index) => {
      if (index < elementRefs.current.length && !hasUserScrolled) {
        isAutoScrolling.current = true;
        elementRefs.current[index].current.scrollIntoView({
          behavior: "smooth",
          block: "end",
        });
        setTimeout(() => {
          isAutoScrolling.current = false;
        }, 1000);
        timeoutRef.current = setTimeout(() => scrollToElement(index + 1), 1030);
      }
    };

    scrollToElement(0);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(timeoutRef.current);
    };
  }, [hasUserScrolled]);

  return (
    <div className=" flex justify-end pt-[10px] pb-[240px] text-right   ">
      <Helmet>
        <title>ابدأ من هنا</title>
        <meta name="description" content="صفحه ابدأ من هنا" />
      </Helmet>
      <div className="!pt-0 sm:mt-4 w-full">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate={"visible"}
          className="mt-2 max-w-[1000px] lg:mx-auto max-sm:mx-4 sm:pr-[90px] duration-200 flex flex-col items-end gap-4"
        >
          {contents.map((content, index) => {
            return (
              <motion.div
                key={index}
                variants={itemVariants}
                ref={elementRefs.current[index]}
                className={
                  index >= 12
                    ? "bg-white shadow-md rounded-l-[24px] items-center gap-1 rounded-tr-[26px] py-5 pr-6 pl-8 scroll-offset"
                    : "bg-white shadow-md rounded-l-[24px] items-center gap-1 rounded-tr-[26px] py-5 pr-6 pl-8"
                }
              >
                {content}
              </motion.div>
            );
          })}

          <motion.div
            variants={itemVariants}
            ref={elementRefs.current[16]}
            className=" bg-[#004d5a] shadow-md rounded-[8px] flex items-center gap-1  py-[8px] px-[16px] cursor-pointer scroll-offset"
            onClick={() => {
              navigate("/");
            }}
          >
            <img src="/images/sparkles_2728.png" alt="emoji" className="w-4" />
            <bdi className=" text-white">ابدأ رحلتك</bdi>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default Starter;
